import { NumberBox, NumberBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { toPositiveNumber } from './functions/toPositiveNumber';

export const InterestRateFloorField = () => {
    const value = useStandardLoanStore((state) => state.loan.interestRateFloor);
    const updateLoan = useStandardLoanStore((state) => state.updateLoan);

    return (
        <NumberBox
            id='loanInterestRateFloor'
            value={value}
            onChange={(rate) => updateLoan({ interestRateFloor: toPositiveNumber(rate) })}
            label='Interest Rate Floor'
            format="#0.##'%'"
            width='100%'
            height='36px'
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            labelWidth='150px'
        />
    );
};
